export const mockBoards = [
  { id: '1', name: 'Project Planning', icon: '📋', color: '#4A90A4' },
  { id: '2', name: 'Marketing Campaign', icon: '📢', color: '#00C875' },
  { id: '3', name: 'Product Development', icon: '🚀', color: '#FDAB3D' },
  { id: '4', name: 'Customer Support', icon: '💬', color: '#E44258' },
];

export const mockTasks = [
  {
    id: '1',
    boardId: '1',
    task: 'Design new landing page',
    person: { name: 'Sarah Johnson', avatar: 'SJ', color: '#FF6B9D' },
    status: { value: 'working', label: 'Working on it', color: '#FDAB3D' },
    priority: { value: 'high', label: 'High', color: '#E44258' },
    date: '2025-01-20',
    timeline: 'Q1 2025',
    notes: 'Need to review mockups'
  },
  {
    id: '2',
    boardId: '1',
    task: 'Update user documentation',
    person: { name: 'Mike Chen', avatar: 'MC', color: '#00C875' },
    status: { value: 'done', label: 'Done', color: '#00C875' },
    priority: { value: 'medium', label: 'Medium', color: '#FDAB3D' },
    date: '2025-01-15',
    timeline: 'Q1 2025',
    notes: ''
  },
  {
    id: '3',
    boardId: '1',
    task: 'Fix login bug',
    person: { name: 'Alex Rivera', avatar: 'AR', color: '#579BFC' },
    status: { value: 'stuck', label: 'Stuck', color: '#E44258' },
    priority: { value: 'critical', label: 'Critical', color: '#333333' },
    date: '2025-01-18',
    timeline: 'Q1 2025',
    notes: 'Waiting for backend team'
  },
  {
    id: '4',
    boardId: '1',
    task: 'Prepare Q1 presentation',
    person: { name: 'Emma Wilson', avatar: 'EW', color: '#A25DDC' },
    status: { value: 'review', label: 'Waiting for review', color: '#A25DDC' },
    priority: { value: 'high', label: 'High', color: '#E44258' },
    date: '2025-01-22',
    timeline: 'Q1 2025',
    notes: 'Draft ready'
  },
  {
    id: '5',
    boardId: '1',
    task: 'Code review session',
    person: { name: 'David Kim', avatar: 'DK', color: '#00D2D2' },
    status: { value: 'working', label: 'Working on it', color: '#FDAB3D' },
    priority: { value: 'medium', label: 'Medium', color: '#FDAB3D' },
    date: '2025-01-19',
    timeline: 'Q1 2025',
    notes: ''
  },
];

export const statusOptions = [
  { value: 'working', label: 'Working on it', color: '#FDAB3D' },
  { value: 'done', label: 'Done', color: '#00C875' },
  { value: 'stuck', label: 'Stuck', color: '#E44258' },
  { value: 'review', label: 'Waiting for review', color: '#A25DDC' },
];

export const priorityOptions = [
  { value: 'critical', label: 'Critical', color: '#333333' },
  { value: 'high', label: 'High', color: '#E44258' },
  { value: 'medium', label: 'Medium', color: '#FDAB3D' },
  { value: 'low', label: 'Low', color: '#00C875' },
];